 // copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 // SPDX-License-Identifier: Apache-2.0
 'use strict';
 
 const processInclude = require('base/util');
 
 processInclude(require('./clickstream/clickstreamCollector.js'));
 $(document).ready(function () {
    processInclude(require('./clickstream/miniCart'));
});